/**
 * Lit le corps d'une Response fetch en JSON, avec un message clair si le serveur
 * renvoie du HTML (page SPA, nginx try_files, page de login, etc.).
 */
export async function readApiJson<T = unknown>(response: Response): Promise<T> {
  const text = await response.text();
  const trimmed = text.trim();
  if (!trimmed) {
    if (response.ok) return undefined as T;
    throw new Error(`Réponse vide (HTTP ${response.status} ${response.statusText}) ${response.url}`);
  }
  const start = text.trimStart();
  if (start.startsWith('<!') || start.toLowerCase().startsWith('<html')) {
    const hint =
      'Le serveur a renvoyé du HTML au lieu de JSON. Causes fréquentes : ' +
      '(1) build servi sans proxy /api vers le backend Node ; ' +
      '(2) `vite preview` sans configuration preview.proxy ; ' +
      '(3) nginx / CDN qui sert index.html pour les URLs /api. ' +
      'Démarrer le backend (port 3001) et utiliser `npm run dev`, ou configurer le proxy /api.';
    throw new Error(`${hint} [HTTP ${response.status} ${response.statusText}] ${response.url}`);
  }
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error(
      `Réponse non JSON valide (HTTP ${response.status}). Début du corps : ${text.slice(0, 160)}…`
    );
  }
}
